import { ShineStarsFx } from '../../components/ShineStarsFX';
import { IAnimation } from '../../lib/pattern/IAnimation';
import { Container, Sprite } from '../../odie';

const manifest = {
  super: 'power/block.cube.super.png',
  blueSparkle: 'assets/particles/sparkle_blue.png',
  greenSparkle: 'assets/particles/sparkle_green.png',
  purpleSparkle: 'assets/particles/sparkle_purple.png',
  redSparkle: 'assets/particles/sparkle_red.png',
  yellowSparkle: 'assets/particles/sparkle_yellow.png',
  sparkles: 'fx.cube/fx.cube.sparkles.png',
  wave: 'fx.bomb/fx.bomb.wave.png',
  shine: 'fx.cube/fx.cube.shine.png',
};

export class SuperCubeOverlayAnimation extends Container implements IAnimation {
  private container: Container;
  private image: Sprite;
  private shine1: Sprite;
  private shine2: Sprite;
  private sparkles: ShineStarsFx;
  public speed = 1;
  public wobble = 0;

  constructor() {
    super();

    this.container = new Container();
    this.addChild(this.container);

    this.image = Sprite.from(manifest.super);
    this.image.anchorX = this.image.anchorY = 0.5;
    this.image.pivotY = -2;
    this.image.zIndex = 2;
    this.image.scaleX = this.image.scaleY = 0.7;
    this.container.addChild(this.image);

    this.shine1 = Sprite.from(manifest.shine);
    this.shine1.anchorX = this.shine1.anchorY = 0.5;
    this.shine1.rotation = -Math.PI * 2;
    this.container.addChild(this.shine1);

    this.shine2 = Sprite.from(manifest.shine);
    this.shine2.anchorX = this.shine2.anchorY = 0.5;
    this.shine2.rotation = -Math.PI * 2;
    this.container.addChild(this.shine2);

    this.sparkles = new ShineStarsFx({
      superview: this.view,
      width: 60,
      height: 60,
      centerOnOrigin: true,
      zIndex: 3,
    });
    this.sparkles.play();
  }

  public async start() {
    this.sparkles.play();
  }

  public stop() {
    this.sparkles.stop();
  }

  public update(dt: number) {
    this.image.rotation += dt * -0.3 * this.speed;
    this.shine1.rotation += dt * -0.02;
    this.shine2.rotation += -dt * -0.07;

    if (this.wobble) {
      const wobble = Math.sin(this.image.rotation * 2) * this.wobble;
      this.container.scaleX = 1 + wobble;
      this.container.scaleY = 1 - wobble;
    }
  }
}
